import { useContext, useEffect } from 'react';

import { PORTFOLIO_TABS_NAME } from '../../../../../constants/reports/reports-data';
import { GlobalContext } from '../../../../../providers/global-provider';
import {
  DATA_DISPLAY_KEYS,
  DataParent,
  PortfolioManagementContext,
} from '../../../../../providers/portfolio-management';
import {
  STRIKE_REPORT_INITIAL_DATA,
  StrikeReportContext,
} from '../../../../../providers/strike-report';

export const usePerAccountStrikeReportEffect = () => {
  const { portfolioCurrentTab } = useContext(GlobalContext);
  const { getDataFromAccount, selectedDataDisplayOption, selectedAccountOption } = useContext(
    PortfolioManagementContext,
  );
  const {
    isStrikeReportLoading,
    getStrikeReportData,
    setStrikeReportData,
    strikeReportFilters: {
      strikeReportFilterToken: { token },
      setStrikeReportFilterToken,
    },
  } = useContext(StrikeReportContext);

  const isDataDisplayPerAccount = selectedDataDisplayOption === DATA_DISPLAY_KEYS.perAccount;
  const dataParent: DataParent = PORTFOLIO_TABS_NAME.strikeReport as DataParent;

  useEffect(() => {
    if (
      isStrikeReportLoading ||
      !isDataDisplayPerAccount ||
      portfolioCurrentTab !== PORTFOLIO_TABS_NAME.strikeReport
    ) {
      return;
    }

    const strikeDataAcc = getDataFromAccount(dataParent, selectedAccountOption);

    if (!strikeDataAcc) {
      getStrikeReportData({ accounts: selectedAccountOption });
      return;
    }

    if (strikeDataAcc.error) {
      setStrikeReportData({
        ...STRIKE_REPORT_INITIAL_DATA,
        isError: true,
      });
      return;
    }

    const report = strikeDataAcc?.data?.report;
    if (!report) {
      setStrikeReportData(STRIKE_REPORT_INITIAL_DATA);
      return;
    }

    const tokenKeys = Object.keys(report).sort((a, b) => a.localeCompare(b));
    if (tokenKeys.length === 0) {
      setStrikeReportData(STRIKE_REPORT_INITIAL_DATA);
      return;
    }

    const currentToken = tokenKeys.includes(token) ? token : tokenKeys[0];
    const reportDataToken = report[currentToken];

    if (strikeDataAcc.data && reportDataToken) {
      setStrikeReportData({
        data: reportDataToken,
        lastUpdate: strikeDataAcc.lastUpdate,
        isError: false,
      });

      setStrikeReportFilterToken((state: any) => ({
        ...state,
        token: currentToken,
        tokenList: tokenKeys.map((tokenKey) => ({
          value: tokenKey,
          name: tokenKey,
          isVisible: true,
          isDefault: tokenKey === currentToken,
        })),
      }));
      return;
    }

    setStrikeReportData(STRIKE_REPORT_INITIAL_DATA);
  }, [
    selectedAccountOption,
    isStrikeReportLoading,
    portfolioCurrentTab,
    isDataDisplayPerAccount,
    token,
  ]);
};
